/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { IStore } from '../IStore';

export const getCurrentLocation = (state: IStore): string => state.router.location.pathname;
export const getCurrentLocationState = (state: IStore) => state.router.location.state;
